import { render, staticRenderFns } from "./AlaskaCTA.vue?vue&type=template&id=65997812&scoped=true"
import script from "./AlaskaCTA.vue?vue&type=script&lang=js"
export * from "./AlaskaCTA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65997812",
  null
  
)

export default component.exports